const ru = {
    9000001: "Новогодний трофей 2023 года",
    9000002: "Турнир SuperEx Futures",
    9000003: "30 000 USDT в качестве призов",
    9000004: "Количество участников",
    9000005: "Разблокированный призовой фонд (USDT)",
    9000006: "Отборочный конкурс рейтинга торговых объемов",
    9000007: `Отборочный конкурс "Рейтинг прибыли`,
    9000008: `Отборочный конкурс "Профит Рейтинг"`,
    9000009: `Конкурс рейтинга торговых объемов: Разблокируйте главный приз - бонусный пул в размере <span style="color: #ffc72b;">20,000</span> USDT. `,
    9000010: "В зависимости от количества участников, чем больше участников, тем больший призовой фонд будет разблокирован, вплоть до 20 000USDT. ",
    9000011: "Призовой фонд",
    9000012: "Обновляется ежедневно в 10:00 UTC в период проведения события",
    9000013: "Расчет бонуса ",
    9000014: "Совокупный объем торговли фьючерсами",
    9000015: "Правила бонусов",
    9000016: "В зависимости от количества участников, чем больше участников, тем больший призовой фонд будет разблокирован, вплоть до 20 000USDT. ",
    9000017: "Призовой фонд (USDT)",
    9000018: "Рейтинг прибыльности событий",
    9000019: "Регистрация",
    9000020: "Рейтинг прибыли события",
    9000021: "Завершено",
    9000022: `Конкурс "Рейтинг прибыли" - получите бонус <span style="color: #ffc72b;">{moneyPond}</span> USDT `,
    9000023: `Отборочный конкурс "Профит Рейтинг" - получите бонус <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000024: "Кумулятивная прибыль по фьючерсам",
    9000025: "Общая прибыль",
    9000026: "Не начато",
    9000027: `50 лучших участников конкурса "Рейтинг прибыли" получат награды. Для получения награды ознакомьтесь с правилами получения бонусов.`,
    9000028: "50 лучших участников по прибыльности получат награды, пожалуйста, обратитесь к Правилам награждения за торговый рейтинг, чтобы получить награды. ",
    9000029: "Рейтинг объема торгов в рамках акции",
    9000030: "Регистрация прошла успешно",
    9000031: "Скачайте приложение",
    9000032: "Вернуться домой",

    //合约交易积分
    9100001: 'Сохранить очки',
    9100002: 'Получить Airdrop',
    9100003: 'Обменять бонусы',
    9100004: 'Баланс очков',
    9100005: 'Подробности',
    9100006: 'Очки за регистрацию',
    9100007: 'Торговые очки',
    9100008: 'Пригласительные очки',
    9100009: 'Бонусные очки',
    9100010: 'Розыгрыш призов',
    9100011: '获取积分',
    9100012: 'Правила начисления очков',
    9100013: '',
    9100014: '',
    9100015: 'Торговали в течение {day} дней подряд и заработали {num} очков',
    9100016: 'Очки, заработанные сегодня {num}',
    9100017: 'Призовой фонд в очках',
    9100018: 'Каждый счастливый розыгрыш расходует {point} очков, и в день можно разыграть максимум {num} счастливых розыгрыша.',
    9100019: 'Количество розыгрышей сегодня',
    9100020: 'Пользователь',
    9100021: 'Очки',
    9100022: 'Баланс очков недостаточен',
    9100023: 'Баланс очков недостаточен. Пожалуйста, наберите очки перед участием в розыгрыше.',
    9100024: 'Количество розыгрышей достигло предела!',
    9100025: 'Количество счастливых розыгрышей за сегодня достигло предела. Повторите попытку завтра.',
    9100026: 'Как получить очки',
    9100027: 'Зарегистрируйтесь для участия в акции по начислению очков за торговлю фьючерсами.',
    9100028: 'Успешная регистрация',
    9100029: 'Вы зарегистрировались, чтобы принять участие в торговле фьючерсами и заработать очки. Переходите и торгуйте, чтобы заработать больше очков (вы больше не будете получать комиссию и награду в виде кешбэка).',
    9100030: 'После отмены регистрации вы больше не будете получать очки. Вы уверены, что хотите отменить регистрацию?',
    9100031: 'Центр активности торговых очков',
    9100032: 'Получить очки',
    9100033: 'Чтобы принять участие в акции, необходимо зарегистрироваться. Нажмите, чтобы зарегистрироваться',
    9100034: 'Вы можете зарабатывать очки, постоянно торгуя фьючерсами',
    9100035: 'Пользователи могут зарабатывать очки за все сделки с фьючерсами',
    9100036: 'Очки в таблице лидеров',
    9100037: 'Пять лучших пользователей в ежедневном торговом рейтинге получат дополнительные бонусные очки',
    9100038: 'Приглашенные пользователи получают очки, а пригласивший может получить бонусные очки.',
    9100039: '{guy} Уже выиграл {num} очки!',
    9100040: 'Попробуйте Lucky Draw прямо сейчас!',
    9100041: 'Поздравляем с получением',
    9100042: 'Все типы',
    9100043: 'Остаться на этой странице',
    9100044: 'Зарегистрироваться для участия',
    9100045: 'Продолжить торговлю',
    9100046: 'В настоящее время никаких текущих мероприятий не проводится. Пожалуйста, продолжайте следить за последними новостями.',
    9100047: 'Погасить токены SCS',
    9100048: '',
    9100049: '',

    9100050: 'Даты',
    9100051: 'Выберите дату начала',
    9100052: 'Выберите дату окончания',
    9100053: 'к',
    9100054: 'Тип',

    9100055: 'Points earned = trading volume * 1% (the difficulty will be further adjusted as the total trading volume of the platform increases)',
    9100056: 'For example: the user uses a position with a margin of 100 USDT*100X=10000 USDT',
    9100057: 'Then you only need a deposit of 100 USDT to get 100 points',
    9100058: 'Trading points are the only way to obtain the platform token SCS',
    9100059: 'Extra bonus points = total points for the day * ranking reward ratio',
    9100060: 'Ranking',
    9100061: 'First place',
    9100062: 'Second place',
    9100063: 'Third place',
    9100064: 'Fourth place',
    9100065: 'Fifth place',
    9100066: 'Invited users receive points and the inviter can receive bonus points.',
    9100067: 'Level factor ',
    9100068: 'Calculation formula: referral points obtained = points obtained by the invitee * level coefficient',
    9100069: 'The level coefficient will be adjusted according to the actual situation',
    9100070: 'For example: User B participates in a points activity, and its inviter is User A, and the number of invitations from User A has reached Level 3. User B has accumulated points = 360,000;',
    9100071: 'Then the cumulative promotion points that user A can obtain = 360000* 30% = 108,000',
    9100072: 'Reward coefficient ',
    9100073: '1 Trading users ',
    9100074: 'The trading volume reaches 5 million ',
    9100075: 'The trading volume reaches 20 million ',

    9100076: 'Перевод',

    //热币
    9100080: 'Все кончено.',
    9100081: 'Нажмите "Присоединяйтесь немедленно", чтобы выиграть награду',
    9100082: 'Посмотреть Правила',
    9100083: 'Присоединиться',
    9100084: 'Активночть',
    9100088: 'Торговля',
    9100089: 'Депозит',
    9100090: 'Вы уже зарегистрированы.',

    9100091: 'Это событие закончилось, ждите следующего события!',
    9100092: 'Мероприятие еще не началось, пожалуйста, оставайтесь на связи.',
    9100093: '',
    9100094: '',

    //自由区二维码分享页面
    9100095: 'SuperEx Free Market, криптовалютный мир пользователей, от пользователей, для пользователей!',
    9100096: 'Откройте приложение',
    9100097: '',
    9100098: '',
}
export default ru



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/ru.js